module.exports = __webpack_public_path__ + "static/media/29_B.940b8d06.png";